import { type UseQueryResult, useQuery } from 'react-query';
import {
  PsuAwardService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_PsuAwardListDto,
} from '@wealthlane/api-services/wealthlane-award-service';
// import { ParticipantService } from '@wealthlane/api-services/wealthlane-customer-service';
import { type TableParamsType } from '../../types/common';

const useGetPsuParticipantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  filterData: TableParamsType,
  tableInfo: TableParamsType & {
    fromApproveDate?: string;
    toApproveDate?: string;
    fromPublishDate?: string;
    toPublishDate?: string;
  },
  enabled?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_PsuAwardListDto | undefined,
  unknown
> => {
  // const {
  //   approvalStatusId,
  //   optionAcceptance: psuAcceptance,
  //   fromDate,
  //   toDate,
  //   createdFromDate,
  //   createdToDate,
  //   employeeStatusId,
  //   grantFromDate,
  //   grantToDate,
  // } = filterData;

  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    approvalStatusId,
    optionAcceptance: psuAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    employeeStatusId,
    grantFromDate,
    grantToDate,
    fromApproveDate,
    toApproveDate,
    fromPublishDate,
    toPublishDate,
    _force,
  } = tableInfo;
  const psuStatus = 0;

  const PsuParticipantList = useQuery(
    [
      'getPsuParticipantList',
      approvalStatusId,
      fromDate,
      toDate,
      employeeStatusId,
      psuStatus,
      psuAcceptance,
      createdFromDate,
      createdToDate,
      grantFromDate,
      grantToDate,
      fromApproveDate,
      toApproveDate,
      fromPublishDate,
      toPublishDate,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        PsuAwardService.getApiAwardApiAppPSUAwardPSUAwardList(
          approvalStatusId ?? [0],
          employeeStatusId ?? [0],
          psuStatus,
          psuAcceptance,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          fromApproveDate,
          toApproveDate,
          fromPublishDate,
          toPublishDate,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    },
    {
      enabled: enabled !== false,
    }
  );

  return PsuParticipantList;
};

export default useGetPsuParticipantList;
